import { GroupChannelFilter } from '@sendbird/chat/groupChannel';
import { useSendbirdChat } from '@sendbird/uikit-react-native';
import { useGroupChannelList } from '@sendbird/uikit-tools';
import { countUnreadChannels } from '../utils/unreadChannels';

export const useUnreadChannelsCount = (): number => {
    const { sdk } = useSendbirdChat();
    const { groupChannels } = useGroupChannelList(sdk, {
        collectionCreator: (defaultParams) =>
            sdk.groupChannel.createGroupChannelCollection({
                ...defaultParams,
                filter: new GroupChannelFilter({ ...defaultParams, includeEmpty: true }),
            }),
    });

    return countUnreadChannels(groupChannels);
};
